var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pagination-impl',_vm._g({attrs:{"value":_vm.effectiveValue,"records":_vm.records,"per-page":_vm.perPage,"options":_vm.options}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }